import { render, staticRenderFns } from "./MemberTagSetting.vue?vue&type=template&id=2d1359f6&scoped=true"
import script from "./MemberTagSetting.vue?vue&type=script&lang=js"
export * from "./MemberTagSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1359f6",
  null
  
)

export default component.exports